<template>
  <div
    :class="[
      'asc-doc-mgmt-dialog',
      !isConfirmation ? 'asc-doc-mgmt-dialog--unsaved' : '',
    ]"
  >
    <asc-dialog
      :show-dialog="showDialog"
      :text="dialogTitle"
      :on-primary="handleSaveExitSession"
      :on-secondary="handleContinueSession"
      :secondary-button-text="secondaryButtonText"
      :primary-button-text="primaryButtonText"
      >{{ dialogText }}</asc-dialog
    >
  </div>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'

export default {
  name: 'AscDocMgmtDialog',

  components: {
    AscDialog,
  },

  mixins: [AscDialogMixin],

  props: {
    isConfirmation: {
      type: Boolean,
      default: false,
    },
    onSaveExitSession: {
      type: Function,
      required: true,
    },
    onContinueSession: {
      type: Function,
      required: true,
    },
  },

  computed: {
    dialogText() {
      return this.isConfirmation
        ? 'You are about to exit this page without saving your changes. Please choose to continue editing or save and exit.'
        : 'There are changes that have been saved. If you continue, you will lose all unsaved changes.'
    },
    dialogTitle() {
      return this.isConfirmation ? 'Confirm' : 'Unsaved Changes'
    },
    primaryButtonText() {
      return this.isConfirmation ? 'Publish & Exit' : 'Cancel & Save'
    },
    secondaryButtonText() {
      return this.isConfirmation
        ? 'Continue Editing'
        : 'Continue without saving'
    },
  },

  methods: {
    handleSaveExitSession() {
      this.onSaveExitSession()
      this.handleClose()
    },
    handleContinueSession() {
      this.onContinueSession()
      this.handleClose()
    },
  },
}
</script>

<style lang="scss">
.asc-doc-mgmt-dialog {
  .asc-dialog {
    .v-card__text {
      min-height: 120px !important;
      padding: 16px 16px 19px !important;
    }
  }

  &.asc-doc-mgmt-dialog--unsaved {
    .asc-dialog {
      width: 436px !important;
    }
  }
}
</style>
